export default class DocumentsClient {
    constructor(apiClient) {
        this.documentsUri = '/v3/documents';
        this.apiClient = apiClient;
        this.putDocument = this.putDocument.bind(this);
        this.deleteDocument = this.deleteDocument.bind(this);
        this.getDocuments = this.getDocuments.bind(this);
        this.getDocument = this.getDocument.bind(this);
        this.getDocumentVersions = this.getDocumentVersions.bind(this);
        this.getDocumentVersion = this.getDocumentVersion.bind(this);
        this.getDocumentDownloadUrl = this.getDocumentDownloadUrl.bind(this);
        this.getDocumentUploadUrl = this.getDocumentUploadUrl.bind(this);
    }
    // Documents
    putDocument(id, data, config) {
        return this.apiClient.put(`${this.documentsUri}/${id}`, data, config);
    }
    deleteDocument(id, config) {
        return this.apiClient.delete(`${this.documentsUri}/${id}`, config);
    }
    getDocuments(config) {
        return this.apiClient.get(this.documentsUri, config);
    }
    getDocument(id, config) {
        return this.apiClient.get(`${this.documentsUri}/${id}`, config);
    }
    getDocumentVersions(id, config) {
        return this.apiClient.get(`${this.documentsUri}/${id}/versions`, config);
    }
    getDocumentVersion(id, updateId, config) {
        return this.apiClient.get(`${this.documentsUri}/${id}/versions/${updateId}`, config);
    }
    getDocumentDownloadUrl(id, config) {
        return this.apiClient.get(`${this.documentsUri}/${id}/download_url`, config);
    }
    getDocumentUploadUrl(id, config) {
        return this.apiClient.get(`${this.documentsUri}/${id}/upload_url`, config);
    }
}
